import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const items = ['más tranquilo', 'menos agotado emocionalmente', 'más seguro para poner límites', 'menos manipulable', 'con más claridad mental', 'con más paz en tu vida diaria'];
export function TransformationSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-365">
      <div className="max-w-4xl mx-auto text-center" data-id="element-366">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-367">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-368">
            <span className="text-xs font-bold tracking-widest" data-id="element-369">
              LA TRANSFORMACIÓN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-370">
            Imaginá{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-371">
              sentirte…
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3 mb-12 text-left" data-id="element-372">
          {items.map((it, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white border border-line rounded-2xl p-5 flex items-center gap-3 shadow-sm" data-id="element-373">
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/10 flex items-center justify-center" data-id="element-374">
                <CheckIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-375" />
              </span>
              <span className="text-ink font-medium" data-id="element-376">{it}</span>
            </motion.div>)}
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-377">
          <p className="font-serif-italic text-2xl md:text-3xl leading-relaxed text-ink" data-id="element-378">
            "No se trata de cambiar a todo el mundo. Se trata de aprender a{' '}
            <span className="text-rose font-semibold not-italic" data-id="element-379">
              protegerte mejor
            </span>
            ."
          </p>
        </motion.blockquote>
      </div>
    </section>;
}